// DEX venue identity for the frontend -- data-driven via /api/v1/bindings
// (venue_pair_map.venue_type). On CLMM venues the pool's own mid moves
// mechanically with each swap, so quoted spread is all-zero by construction
// and Huang-Stoll adverse-selection is invalid -- the dashboard shows
// LP-markout-vs-reference instead, and suppresses the quote-quality card +
// quoted-spread chart.
//
// The set is registered by fetchBindings() (bindings.ts) before any panel
// renders; isDexVenue keeps its (venue: string) => boolean signature so its
// three consumers (QuoteFreshnessChip, EffectiveSpreadPanel, DepthView) are
// untouched by the refactor.
let DEX_VENUES: ReadonlySet<string> = new Set<string>();

export function setDexVenues(venues: Iterable<string>): void {
  DEX_VENUES = new Set(venues);
}

export function isDexVenue(venue: string): boolean {
  return DEX_VENUES.has(venue);
}
